<template>
  <div class="app-order-personal-data accordion-inner">
    <slot name="txtBefore"></slot>
    <div class="app-personal-data-content">
      <personal-data-full-form :person.sync="customer" :emailRepeat.sync="emailRepeat" :invalid.sync="personalDataInvalid">
        <template v-for="slot in possibleChildSlotsFor('PersonalDataForm')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </personal-data-full-form>
      <slot name="txtBetween"></slot>
      <country-input
        :identType.sync="identInformation.identType"
        :dataMatchIdent.sync="identInformation.dataMatchIdent"
        :nationality.sync="identInformation.nationality"
        :ident-card.sync="identInformation.identCard"
        :invalid.sync="countryInputInvalid"
        operation-name="order"
      >
        <template v-for="slot in possibleChildSlotsFor('CountryInput')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </country-input>
    </div>
    <div class="order-step">
      <b-overlay class="btn-next-overlay" :show="loading" spinner-small>
        <b-button @click="next" :disabled="loading || personalDataInvalid || countryInputInvalid" class="btn-next" type="button" variant="primary">
          <slot name="btnNext">weiter</slot>
        </b-button>
      </b-overlay>
    </div>
    <slot name="txtAfter"></slot>
  </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PersonalDataFullForm from '@/components/process/generic/PersonalData/fyve/PersonalDataFullForm.vue'
import CountryInput from '@/components/process/generic/IdentMethod/InputCountryData.vue'
import slotProxy from '@/mixins/slotProxy'
import preFilledObjectInput from '@/mixins/preFilledObjectInput'
import preFilledInput from '@/mixins/preFilledInput'

export const stepName = 'personalData'
const initialValues = {
  customer: {
    address: {
      city: '',
      houseNumber: '',
      street: '',
      zip: '',
      supplement: ''
    },
    birthDate: '',
    email: '',
    firstName: '',
    gender: '',
    lastName: '',
    password: ''
  },
  identInformation: {
    identType: '',
    dataMatchIdent: false,
    nationality: '',
    identCard: ''
  }
}
export default {
  name: 'PersonalData',
  data () {
    return {
      loading: false,
      personalDataInvalid: true,
      countryInputInvalid: true
    }
  },
  components: {
    PersonalDataFullForm,
    CountryInput
  },
  methods: {
    async next () {
      this.loading = true
      const customerData = {
        gender: this.customer.gender,
        firstName: this.customer.firstName,
        lastName: this.customer.lastName,
        birthDate: this.customer.birthDate
      }
      const address = this.customer.address
      const additional = { email: this.customer.email }
      await this.validate({
        customer: customerData,
        address: address,
        identInformation: this.identInformation,
        additional: additional,
        nextStep: this.nextStep
      })
      this.loading = false
    },
    ...mapActions('orderProduct/personalData', [
      'validate'
    ])
  },
  mixins: [
    slotProxy(),
    preFilledObjectInput('customer', 'getCustomer'),
    preFilledObjectInput('identInformation', 'getIdentInformation'),
    preFilledInput('emailRepeat', 'getEmailRepeat')
  ],
  computed: {
    ...mapGetters('orderProduct/personalData', {
      storedCustomer: 'customerCore',
      storedIdentInformation: 'identificationFull',
      storedEmail: 'email'
    }),
    getCustomer () {
      return { ...initialValues.customer, ...this.storedCustomer }
    },
    getIdentInformation () {
      return { ...initialValues.identInformation, ...this.storedIdentInformation }
    },
    getEmailRepeat () {
      if (this.storedEmail == null) {
        return ''
      } else {
        return this.storedEmail
      }
    }
  },
  props: {
    nextStep: {
      type: String,
      default: 'payment'
    }
  }
}
</script>
